import { render, staticRenderFns } from "./AS_BijuleeNewsBulletin.vue?vue&type=template&id=78790e9e&scoped=true&"
import script from "./AS_BijuleeNewsBulletin.vue?vue&type=script&lang=js&"
export * from "./AS_BijuleeNewsBulletin.vue?vue&type=script&lang=js&"
import style0 from "./AS_BijuleeNewsBulletin.vue?vue&type=style&index=0&id=78790e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78790e9e",
  null
  
)

export default component.exports